import React, {useState} from 'react';

import ReadAllButton from '../../../components/UserNotifications/NotificationTagFilter/ReadAllButton/ReadAllButton';
import TagList from '../../../components/UserNotifications/NotificationTagFilter/TagList/TagList';
import {IconChevronBottomBlack} from '../../Icons';

const NotificationTagFilter = ({selectedTag, categoryCounts, onTagClick, onReadAllClick}) => {
    const [isCategoriesOpened, setIsCategoriesOpened] = useState(true);

    return (
        <div
            className='
                sticky top-0 z-10 w-full px-4 pb-4
                bg-white bg-opacity-90 backdrop-blur-md
                border-b border-whisper shadow-sm
            '
        >
            <div className={`flex justify-between items-center ${isCategoriesOpened ? 'mb-3.5' : 'mb-0 md:mb-3.5'}`}>
                <span className='hidden text-12 font-bold text-nobel uppercase tracking-05 select-none md:inline'>
                    Категорії
                </span>

                <button
                    type='button'
                    aria-expanded={isCategoriesOpened}
                    className='flex flex-1 items-center gap-2 text-left md:hidden'
                    onClick={() => setIsCategoriesOpened((isOpened) => !isOpened)}
                >
                    <span className='text-12 font-bold text-nobel uppercase tracking-05 select-none'>Категорії</span>
                    <IconChevronBottomBlack
                        className={`duration-150 ${isCategoriesOpened ? 'rotate-180' : 'rotate-0'}`}
                    />
                </button>

                <ReadAllButton onClick={onReadAllClick} />
            </div>

            <div className={isCategoriesOpened ? 'block' : 'hidden md:block'}>
                <TagList selectedTag={selectedTag} categoryCounts={categoryCounts} onTagClick={onTagClick} />
            </div>
        </div>
    );
};

export default NotificationTagFilter;
